// extracted by mini-css-extract-plugin
export default {"setting":"setting__vajeHRCu","disabled":"disabled__df9aSbI4","label":"label__yXwYQLOH","tag":"tag__B7WEfyG4"};